import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-input-with-button',
    imports: [CommonModule, ReactiveFormsModule, FormsModule],
    templateUrl: './input-with-button.component.html',
    styleUrl: './input-with-button.component.css'
})
export class InputWithButtonComponent {
  @Input() inputWithButton: any[] = [];
}
